import { PhoneInput } from '~/components/ui/phone-input'
import { useFieldContext } from '~/hooks/form-hooks'
import { Field, type FieldProps } from './field'

type PhoneFieldProps = React.ComponentProps<typeof PhoneInput> &
  Omit<FieldProps, 'children' | 'error'>

export function PhoneField({ label, id, optional, className, ...props }: PhoneFieldProps) {
  const field = useFieldContext<string>()

  const errorMessage = (field.state.meta.errors as { message: string }[]).at(0)?.message

  return (
    <Field
      label={label}
      id={id}
      optional={optional}
      required={props.required}
      error={errorMessage}
      className={className}
    >
      <PhoneInput
        {...props}
        id={field.name}
        name={field.name}
        onBlur={field.handleBlur}
        onChange={(v) => {
          field.handleChange(v)
        }}
        aria-invalid={errorMessage !== undefined}
        value={field.state.value}
      />
    </Field>
  )
}
